export const LOADER_ON = 'LOADER_ON';
export const LOADER_OFF = 'LOADER_OFF';

export const TOASTER_ON = 'TOASTER_ON';
export const TOASTER_OFF = 'TOASTER_OFF';
